import type { I18nDict } from '../types.ts'

export const fr: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Réglages',
  section_language: 'Langue',
  section_identity: 'Identité locale',
  section_updates: 'Mise à jour de l\'app',
  section_notifications: 'Notifications',
  section_theme: 'Thème visuel',
  section_backup: 'Sauvegarde des chats',
  section_privacy_network: 'Confidentialité réseau',
  section_media: 'Multimédia',
  section_security: 'Sécurité et mot de passe',
  section_exit: 'Fermer et détruire les données',
  toggle_external_links: 'Recevoir et afficher les liens externes',
  hint_external_links: 'Si DÉSACTIVÉ : pas d\'aperçu de liens dans le chat et les URL externes ne peuvent pas être ouvertes (protection contre le suivi IP).',
  toggle_auto_media: 'Téléchargement automatique des médias et documents',
  hint_auto_media: 'Si DÉSACTIVÉ : photos, vidéos et fichiers ne sont pas téléchargés en arrière-plan — appuyez manuellement dans le chat.',
  toggle_require_unlock: 'Mot de passe à l\'ouverture de l\'app',
  hint_require_unlock: 'Lorsque ACTIVÉ, le mot de passe principal est requis à chaque ouverture de ZION.',
  toggle_wipe_exit: 'Effacer les données à la fermeture',
  hint_wipe_exit: 'Lorsque ACTIVÉ, la fermeture de l\'app efface le cache RAM temporaire et les données de session.',
  btn_exit: 'Quitter',
  btn_delete_all: 'SUPPRIMER TOUTES LES DONNÉES',
  btn_lock: 'Verrouiller l\'app',
  btn_back: 'Retour',
  warn_disable_password_title: '⚠️ AVERTISSEMENT',
  warn_disable_password_body: 'Désactiver le mot de passe d\'ouverture signifie que toute personne ayant accès à votre appareil pourra lire vos messages chiffrés. Êtes-vous sûr de vouloir continuer ?',
  warn_delete_all_1: 'Voulez-vous vraiment détruire toute la base de données ? Cette action est irréversible.',
  warn_delete_all_2: 'Confirmation finale : tous les chats, clés privées et réglages seront définitivement supprimés.',
  link_blocked: 'Lien externe bloqué (paramètres de confidentialité).',
  lang_welcome_title: 'Bienvenue sur ZION',
  lang_welcome_sub: 'Choisissez votre langue',
  lang_continue: 'Continuer',
  settings_language_label: 'Langue de l\'app',
  auth_unlock_title: 'Déverrouiller',
  auth_or_password: '— ou déverrouiller avec le mot de passe —',
  auth_password_master: 'Mot de passe principal',
  auth_unlock_btn: 'Déverrouiller',
  auth_verifying: 'Vérification…',
  auth_wrong_password: 'Mot de passe incorrect',
  auth_unlocked: 'Déverrouillé ✓',
  auth_access_title: 'Rejoindre ZION',
  auth_beta_spots: 'Bêta gratuite · places restantes :',
  auth_beta_full: 'Bêta complète ({max} utilisateurs). Réessayez plus tard.',
  auth_beta_free: 'Bêta gratuite · aucune licence requise',
  auth_or_create: '— ou créer une nouvelle identité —',
  auth_password_min: 'Mot de passe (min. 8 caractères)',
  auth_password_confirm: 'Confirmer le mot de passe',
  auth_privacy_check: 'J\'ai lu la',
  auth_privacy_link: 'Politique de confidentialité',
  auth_terms_check: 'J\'accepte les',
  auth_terms_link: 'Conditions d\'utilisation',
  auth_password_local_hint: 'Le mot de passe ne quitte jamais cet appareil. Aucun compte serveur.',
  auth_create_identity: 'Créer une identité',
  auth_accept_legal_err: 'Acceptez la confidentialité et les conditions pour continuer',
  auth_generating_keys: 'Génération des clés et de la session…',
  auth_generating_identity: 'Génération de l\'identité anonyme…',
  auth_generating_detail: 'Clés ECDH · pseudonyme · session socket · code ZN-',
  auth_you_are: 'Vous êtes',
  auth_daily_suffix_hint: 'Le suffixe quotidien change chaque jour UTC. Pour vous apparier, utilisez le code ZN- sur l\'accueil.',
  auth_enter: 'Entrer dans ZION',
  auth_starting: 'Démarrage…',
  auth_restore_title: 'Restaurer la sauvegarde',
  auth_restore_hint: 'Vous avez déjà une sauvegarde chiffrée ? Récupérez identité, contacts et chats (par ex. après avoir vidé le cache).',
  auth_restore_file: 'Fichier de sauvegarde (.enc / .enc.json)',
  auth_restore_pass: 'Phrase secrète de sauvegarde',
  auth_restore_pass_ph: 'Phrase secrète utilisée à l\'export',
  auth_restore_btn: 'Restaurer la sauvegarde',
  auth_restore_pick_file: 'Sélectionnez un fichier de sauvegarde (.enc ou .enc.json).',
  auth_restore_need_pass: 'Entrez la phrase secrète.',
  auth_restoring: 'Restauration…',
  auth_file_prefix: 'Fichier :',
  common_accept: 'Accepter',
  common_reject: 'Refuser',
  common_cancel: 'Annuler',
  common_accepting: 'Acceptation…',
  common_error: 'Erreur',
  common_loading: 'Chargement…',
  common_send: 'Envoyer',
  common_copied: 'Copié ✓',
  common_copy_failed: 'Échec de la copie',
  common_ok: 'OK',
  common_today: 'Aujourd\'hui',
  common_yesterday: 'Hier',
  common_sending: 'Envoi…',
  home_zn_midnight_hint: 'Change à minuit UTC (dans {h}h {m}m)',
  home_temp_empty: 'Aucun chat temporaire. Appuyez sur ⏱ sur un contact pour en démarrer un.',
  home_unread_aria: '{count} messages',
  home_temp_waiting: 'En attente d\'acceptation…',
  home_temp_expires: 'Chat temporaire · expire dans {remaining}',
  home_temp_cancel: 'Annuler',
  home_temp_fallback_label: 'chat temporaire',
  home_temp_invite_title: '⏱ Invitation à un chat temporaire',
  home_temp_invite_body: '{nick} souhaite un chat éphémère ({duration}).',
  home_temp_invite_hint: 'Acceptez pour commencer à échanger des messages qui disparaîtront à l\'expiration.',
  home_temp_accept: 'Accepter',
  home_temp_reject: 'Refuser',
  home_temp_accepting: 'Acceptation…',
  home_contacts_empty: 'Aucun contact. Partagez votre code ZN- ou QR pour vous apparier.',
  home_temp_chat_aria: 'Chat temporaire',
  home_btn_pair_title: 'Apparier',
  home_btn_settings_title: 'Réglages',
  home_zn_title: 'Code ZN- d\'aujourd\'hui',
  home_btn_copy_zn: 'Copier ZN-',
  home_btn_open_pair: 'QR d\'appariement',
  home_section_temp: 'Chats temporaires',
  home_section_chat: 'Chats',
  home_loading: 'Chargement…',
  home_pair_zn_title: 'Apparier avec le code ZN-',
  home_btn_zn_pair: 'Envoyer la demande',
  home_copied: 'Copié ✓',
  home_copy_failed: 'Échec de la copie',
  home_pair_request_title: 'Demande de contact',
  home_pair_request_body: '{name} souhaite discuter.',
  home_pair_reject: 'Refuser',
  home_pair_accept: 'Accepter',
  home_pair_accepting: 'Acceptation…',
  home_pair_accept_failed: 'Échec de l\'acceptation',
  home_zn_digits_err: 'Entrez les 5 chiffres après ZN-.',
  home_sending: 'Envoi…',
  chat_rename: 'Renommer',
  chat_rename_matrix: '[RENOMMER]',
  chat_rename_title: 'Renommer le contact',
  chat_menu_title: 'Options du chat',
  chat_loading: 'Chargement des messages…',
  chat_reply_to: 'Répondre à',
  chat_cancel_title: 'Annuler',
  chat_voice_lock_hint: 'Glissez vers le haut pour verrouiller l\'enregistrement',
  chat_voice_locked: 'Enregistrement verrouillé — appuyez sur Terminé',
  chat_voice_stop: 'TERMINÉ',
  chat_voice_stop_title: 'Terminé',
  chat_voice_preview_label: 'Aperçu vocal — écoutez avant d\'envoyer',
  chat_voice_send: 'ENVOYER',
  chat_voice_send_title: 'Envoyer',
  chat_timer_label: 'Minuteur',
  chat_timer_title: 'Minuteur de message',
  chat_timer_off: 'DÉSACTIVÉ',
  chat_timer_15s: '15 s',
  chat_timer_30s: '30 s',
  chat_timer_1m: '1 min',
  chat_timer_2m: '2 min',
  chat_photo: 'Photo',
  chat_photo_title: 'Photo',
  chat_voice_hold: 'Maintenir pour enregistrer',
  chat_voice_hold_title: 'Maintenir pour enregistrer',
  chat_doc: 'Doc',
  chat_doc_title: 'Document',
  chat_attach_title: 'Pièces jointes',
  chat_input_placeholder: 'Message chiffré E2E…',
  chat_send: 'Envoyer',
  chat_rename_modal_title: 'Renommer le contact',
  chat_rename_nickname: 'Pseudonyme : @{nick}',
  chat_rename_placeholder: 'Nom personnalisé',
  chat_rename_cancel: 'Annuler',
  chat_rename_save: 'Enregistrer',
  chat_action_reply: '↩ Répondre',
  chat_action_copy: '⎘ Copier',
  chat_action_delete_me: '🗑 Supprimer pour moi',
  chat_action_delete_all: '🗑 Supprimer pour tout le monde',
  chat_action_cancel: 'Annuler',
  chat_menu_clear_me: '🗑 Effacer le chat (pour moi uniquement)',
  chat_menu_clear_all: '🗑 Supprimer le chat pour tout le monde',
  chat_menu_cancel: 'Annuler',
  chat_doc_send_title: 'Envoyer un document',
  chat_doc_default_name: 'document',
  chat_doc_send_hint: 'Le fichier sera compressé, chiffré E2E et envoyé. Max 5 Mo.',
  chat_doc_cancel: 'Annuler',
  chat_doc_send_encrypted: 'Envoyer chiffré',
  chat_doc_too_large: '⚠️ FICHIER TROP VOLUMINEUX : la limite de sécurité maximale pour les documents est de 5 Mo.',
  chat_doc_unsupported: 'Type de document non pris en charge.',
  chat_copy_failed: 'Échec de la copie',
  chat_confirm_delete_me: 'Supprimer ce message uniquement pour vous ?',
  chat_confirm_delete_all: 'Supprimer ce message pour tout le monde ?',
  chat_confirm_clear_all: 'Supprimer tout le chat pour tout le monde ? Cette action est irréversible.',
  chat_confirm_clear_me: 'Effacer le chat uniquement pour vous ?',
  chat_jump_new: '↓ Nouveaux messages',
  chat_empty: 'Aucun message. Écrivez quelque chose pour commencer.',
  chat_voice_err_short: 'Message vocal trop court (minimum 1 seconde).',
  chat_voice_err_long: 'Message vocal trop long (maximum 2 minutes).',
  chat_voice_err_large: 'Message vocal trop volumineux (max 3 Mo).',
  chat_voice_err_start: 'Impossible de démarrer l\'enregistrement vocal.',
  chat_destroyed: '✉ Message lu et détruit',
  chat_destroyed_title: 'Message lu et détruit',
  chat_hold_options: 'Maintenir pour les options',
  chat_reply_fallback: 'Message',
  chat_timer_badge: '⏱ {seconds}s',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'Le code ZN- change à minuit UTC (dans {h}h {m}m).',
  pair_copied: 'Copié ✓',
  pair_copy_failed: 'Échec de la copie',
  pair_title: 'Appariement',
  pair_zn_title: 'Votre code ZN- aujourd\'hui',
  pair_btn_copy_zn: 'Copier le code ZN-',
  pair_tab_mine: 'Mon QR',
  pair_tab_scan: 'Scanner / ZN-',
  pair_qr_aria: 'QR d\'appariement',
  pair_expires_in: 'Expire dans',
  pair_btn_copy_payload: 'Copier la charge utile',
  pair_btn_regen_qr: 'Régénérer le QR',
  pair_qr_hint: 'Montrez ce QR à l\'autre appareil. Valide 10 minutes — compatible avec l\'app Android.',
  pair_expired: 'expiré',
  pair_contact_zn_title: 'Code ZN- du contact',
  pair_zn_prefix_hint: 'Le préfixe <strong>ZN-</strong> est déjà défini — entrez uniquement les 5 lettres/chiffres.',
  pair_btn_zn_request: 'Envoyer la demande ZN-',
  pair_paste_title: 'Ou coller un QR ZION1::',
  pair_paste_hint: 'Collez une charge utile <code>ZION1::</code> ou téléversez une photo du QR.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'Depuis photo / caméra',
  pair_btn_connect_qr: 'Se connecter avec QR',
  pair_zn_digits_err: 'Entrez les 5 chiffres après ZN-.',
  pair_sending: 'Envoi de la demande…',
  pair_reading_qr: 'Lecture du QR…',
  pair_qr_not_found: 'Code QR introuvable dans l\'image.',
  pair_zn_read_ok: 'Code ZN- lu — confirmez avec Envoyer la demande.',
  pair_qr_read_ok: 'QR lu — confirmez avec Se connecter avec QR.',
  pair_qr_read_err: 'Erreur lors de la lecture du QR.',
  settings_identity_hint: 'Mot de passe et clés restent dans ce navigateur. Aucun compte serveur.',
  settings_btn_add_home: 'Guide Ajouter à l\'écran d\'accueil',
  settings_devices_title: 'Appareils liés',
  settings_devices_hint: 'Multi-appareils Zero-Knowledge : les clés voyagent chiffrées E2E. Le serveur n\'est qu\'un relais.',
  settings_btn_link_device: 'Lier un nouvel appareil',
  settings_btn_sync_pc: 'Synchroniser l\'historique PC',
  settings_no_devices: 'Aucun appareil lié.',
  settings_device_self: 'cet appareil',
  settings_version_prefix: 'Version :',
  settings_ios_push_hint: '<strong>iPhone :</strong> notifications = PWA depuis l\'écran d\'accueil + Bannière/Son ACTIVÉ. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'Forcer la mise à jour de l\'app',
  settings_updating: 'Mise à jour…',
  settings_push_mode_prefix: 'Mode :',
  settings_push_hint_ios: '<strong>iPad/iPhone :</strong> les notifications ne fonctionnent qu\'en ouvrant ZION depuis l\'icône de l\'écran d\'accueil (Partager → Ajouter à l\'écran d\'accueil). Dans Safari normal, elles ne sont <em>pas</em> disponibles — même sur iOS 17. Après l\'installation sur l\'écran d\'accueil, revenez ici et appuyez sur Activer les notifications.',
  settings_btn_enable_push: 'Activer les notifications push',
  settings_btn_desktop_notify: 'Notifications bureau (PC)',
  settings_btn_disable_push: 'Désactiver les notifications',
  settings_desktop_requesting: 'Demande d\'autorisation bureau…',
  settings_desktop_ok: 'Notifications bureau actives (son + popup à l\'arrivée d\'un message).',
  settings_desktop_denied: 'Autorisation refusée ou non prise en charge.',
  settings_push_no_session: 'Session non prête.',
  settings_push_requesting: 'Demande d\'autorisation…',
  settings_push_active: 'Notifications actives.',
  settings_push_disabled: 'Notifications désactivées.',
  settings_theme_hint: 'Mêmes thèmes que l\'app ZION Android.',
  settings_theme_recommended: 'Recommandé',
  settings_backup_hint: 'Fichier JSON chiffré avec une phrase secrète (compatible format Android v2). Enregistrez-le sur votre PC : contacts, chats et identité web.',
  settings_backup_pass_label: 'Phrase secrète de sauvegarde',
  settings_backup_pass_ph: 'Phrase secrète dédiée (min. 8 caractères)',
  settings_btn_export_backup: 'Exporter la sauvegarde',
  settings_backup_file_label: 'Restaurer depuis un fichier',
  settings_backup_import_pass_label: 'Phrase secrète de sauvegarde',
  settings_backup_import_pass_ph: 'Phrase secrète utilisée à l\'export',
  settings_btn_import_backup: 'Restaurer la sauvegarde',
  settings_backup_file_prefix: 'Fichier : {name}',
  settings_backup_pass_min: 'La phrase secrète doit comporter au moins 8 caractères.',
  settings_backup_creating: 'Création de la sauvegarde…',
  settings_backup_pick_file: 'Sélectionnez un fichier de sauvegarde (.enc ou .enc.json).',
  settings_backup_need_pass: 'Entrez la phrase secrète de sauvegarde.',
  settings_backup_restoring: 'Restauration…',
  settings_backup_overwrite_confirm: 'Écraser les données locales ?',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 minutes',
  temp_duration_10m: '10 minutes',
  temp_duration_15m: '15 minutes',
  temp_duration_30m: '30 minutes',
  temp_duration_1h: '1 heure',
  temp_duration_6h: '6 heures',
  temp_duration_24h: '24 heures',
  temp_duration_7d: '7 jours',
  temp_remaining_expired: 'Expiré',
  temp_remaining_days: '{days}j {hours}h',
  temp_remaining_hours: '{hours}h {minutes}m',
  temp_remaining_minutes: '{minutes}m',
  temp_remaining_seconds: '{seconds}s',
  temp_screen_subtitle: 'Chat temporaire · messages éphémères',
  temp_empty: 'Aucun message éphémère.',
  temp_empty_hint: 'Écrivez un message éphémère. Il disparaîtra à l\'expiration du minuteur.',
  temp_input_placeholder: 'Message éphémère…',
  temp_send: 'Envoyer',
  temp_waiting_accept: 'En attente que {name} accepte le chat temporaire…',
  temp_waiting_placeholder: 'En attente d\'acceptation…',
  temp_expires_in: 'Expire dans {remaining}',
  temp_duration_title: 'Chat temporaire',
  temp_duration_with: 'Avec {name}',
  temp_duration_hint: 'Choisissez la durée — le chat disparaîtra des deux appareils.',
  temp_sending_invite: 'Envoi de l\'invitation…',
  voice_lock_hint: 'Glissez vers le haut pour verrouiller l\'enregistrement',
  voice_locked: 'Enregistrement verrouillé — appuyez sur Terminé',
  add_home_title: 'Ajouter à l\'écran d\'accueil (iPhone / iPad)',
  add_home_guide_title: 'Guide Safari',
  add_home_step1: 'Ouvrez <strong>Safari</strong> sur cette page (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Appuyez sur <strong>Partager</strong> (carré avec une flèche vers le haut)',
  add_home_step3: 'Choisissez <strong>Ajouter à l\'écran d\'accueil</strong>',
  add_home_step4: 'Ouvrez ZION depuis l\'<strong>icône</strong> — pas depuis un onglet Safari',
  add_home_hint: 'Sur iOS/iPadOS 16.4+, l\'app de l\'écran d\'accueil prend en charge les notifications Web Push et le clavier de chat. Après l\'installation, allez dans <strong>Réglages → Activer les notifications</strong>.',
  add_home_btn_continue: 'Compris — continuer',
  add_home_btn_skip: 'Ignorer pour l\'instant',
  search_title: 'Rechercher avec le code ZN-',
  search_label: 'Code ZN- quotidien',
  search_placeholder: 'ZN-123456',
  search_btn: 'Rechercher',
  search_hint: 'Entrez le code ZN- du contact. Pas de recherche par pseudonyme — l\'identité est locale uniquement.',
  search_format_err: 'Format : ZN-123456',
  search_resolving: 'Résolution du code…',
  search_invalid_code: 'Code invalide — demandez un ZN- à jour (rouvrez ZION sur l\'appareil de l\'autre personne)',
  search_session_found: 'session trouvée',
  search_tap_to_send: 'Appuyez pour envoyer la demande',
  search_socket_not_ready: 'Session socket non prête',
  search_request_sent: 'Demande envoyée ✓',
  search_request_failed: 'Échec de l\'envoi',
  license_title: 'Activation de licence Web / iPhone',
  license_heading: 'Licence',
  license_heading_updated: 'Conditions mises à jour',
  license_hint: 'Entrez le code <strong>ZION-XXXX-XXXX-XXXX</strong> acheté sur zionyx.ch. Il sera lié à ce navigateur (clé locale).',
  license_code_label: 'Code de licence',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Activer la licence',
  license_beta_hint: 'Bêta Web : utilisez une licence iPhone dédiée si disponible.',
  license_accept_legal_err: 'Acceptez la confidentialité et les conditions pour continuer',
  license_need_code: 'Entrez le code de licence',
  license_verifying: 'Vérification de la licence…',
  license_invalid_or_used: 'Licence invalide ou déjà utilisée sur un autre appareil',
  license_active: 'Licence active ✓',
  license_err_not_found: 'Code de licence invalide',
  license_err_conflict: 'Licence déjà liée à un autre appareil',
  license_err_rate_limit: 'Trop de tentatives — attendez une minute',
  license_err_generic: 'Erreur de licence',
  link_device_title: 'Lier un nouvel appareil',
  link_device_hint: 'Sur votre <strong>PC</strong>, ouvrez Réglages → Lier un nouvel appareil : vous verrez le <strong>QR vert</strong>. Scannez-le ensuite ci-dessous (caméra ou photo).',
  link_device_status_ready: '[PRÊT]',
  link_device_upload_label: 'Téléverser une photo QR',
  link_device_btn_camera: 'Ouvrir caméra / galerie',
  link_device_placeholder: 'Lien QR ou charge utile…',
  link_device_btn_send_vault: 'Envoyer le coffre chiffré',
  link_device_err_invalid_qr: 'QR invalide ou expiré.',
  link_device_status_invalid: '[QR INVALIDE]',
  link_device_status_sync_complete: '[SYNCHRONISATION TERMINÉE]',
  link_device_status_transfer_failed: '[ÉCHEC DU TRANSFERT]',
  link_device_status_qr_detected: '[QR DÉTECTÉ — TRANSFERT EN COURS...]',
  link_device_status_tap_camera: '[APPUYEZ SUR LE BOUTON VERT — CAMÉRA IPHONE]',
  link_device_status_use_camera_below: '[UTILISEZ LA CAMÉRA / GALERIE CI-DESSOUS]',
  link_device_status_point_camera: '[POINTEZ LA CAMÉRA VERS LE QR PC...]',
  link_device_status_decoding: '[DÉCODAGE DU QR...]',
  link_device_status_qr_not_found: '[QR INTROUVABLE]',
  link_device_status_decode_failed: '[ÉCHEC DU DÉCODAGE]',
  link_device_status_opened_from_qr: '[OUVERT DEPUIS QR — DÉMARRAGE...]',
  link_recv_title: 'Lier depuis le téléphone',
  link_recv_hint_compact:
    'Scannez ce <strong>QR vert</strong> avec le téléphone (Réglages → Lier un nouvel appareil). Le vault est chiffré de bout en bout.',
  link_recv_hint_auth:
    'Vous avez déjà ZION sur le téléphone ? Scannez ce QR avec l’<strong>Appareil photo</strong> — le PC se lie et se connecte automatiquement.',
  link_recv_qr_alt: 'QR de liaison d’appareil',
  link_recv_copy_link: 'Copier le lien',
  link_recv_awaiting: '[EN ATTENTE DU SCAN TÉLÉPHONE — TUNNEL OUVERT...]',
  link_recv_failed: '[APPARIEMENT ÉCHOUÉ]',
  link_recv_tunnel_lost:
    'Tunnel interrompu — le vault peut encore être en transit. Réessayez de scanner le QR.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Nouveau message chiffré',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Message éphémère',
  force_update_title: '🚨 MISE À JOUR CRITIQUE OBLIGATOIRE — Pour continuer à utiliser Zionyx en toute sécurité, vous devez télécharger la dernière version.',
  force_update_desc: 'Le client installé n\'est pas compatible avec la version minimale active sur le serveur.',
  force_update_versions: 'Installée : v{current} · Requise : v{required}',
  force_update_btn: 'METTRE À JOUR MAINTENANT',
}
